import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { User, Session } from '@supabase/supabase-js';

interface AuthState {
  user: User | null;
  session: Session | null;
  profileError: string | null;
  loading: boolean;
  isPasswordRecovery: boolean;
  profile: {
    id: string;
    user_id: string;
    company_id: string;
    first_name: string | null;
    last_name: string | null;
    preferred_name: string | null;
    email: string;
    role: string | null;
    role_id: string | null;
    address: string | null;
    mobile_phone: string | null;
    date_of_birth: string | null;
    emergency_contact_name: string | null;
    emergency_contact_phone: string | null;
    avatar_url: string | null;
  } | null;
}

const initialState: AuthState = {
  user: null,
  session: null,
  loading: true,
  isPasswordRecovery: false,
  profile: null,
  profileError: null,
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setSession: (state, action: PayloadAction<{ session: Session | null; user: User | null }>) => {
      state.session = action.payload.session;
      state.user = action.payload.user;
      state.loading = false;
    },
    setProfile: (state, action: PayloadAction<AuthState['profile']>) => {
      state.profile = action.payload;
      state.profileError = null;
    },
    setProfileError: (state, action: PayloadAction<string>) => {
      state.profileError = action.payload;
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    setPasswordRecovery: (state, action: PayloadAction<boolean>) => {
      state.isPasswordRecovery = action.payload;
    },
    clearAuth: (state) => {
      state.user = null;
      state.session = null;
      state.profile = null;
      state.profileError = null;
      state.loading = false;
      state.isPasswordRecovery = false;
    },
  },
});

export const { setSession, setProfile, setProfileError, setLoading, setPasswordRecovery, clearAuth } = authSlice.actions;
export default authSlice.reducer;
